<div class="modal-scss">
  <section class="restrictHeight50vh">
    <form [formGroup]="formCreateEditBinder" class="mt-3 row">
      <div class="col-md-9 mb-3 p-fluid">
        <label class="input-label d-block"> {{ 'classification.service' | translate }} * </label>
        <p-treeSelect
          [emptyMessage]="'noResultFound' | translate"
          [options]="servicesParentSingleSelection"
          #treeSelectCreateEditBinder
          class="treeSelectCreateEditBinder"
          selectionMode="single"
          [placeholder]="'pleaseSelectAService' | translate"
          [(ngModel)]="selectedOptionCreateEditBinder"
          [ngModelOptions]="{ standalone: true }"
          appendTo="body"
          (onNodeSelect)="select($event)"
          [filter]="true"
          [filterPlaceholder]="'global.filterPlaceholder' | translate"
          [filterBy]="'label'"
          [filterMode]="'strict'"
          [metaKeySelection]="false">
        </p-treeSelect>
      </div>
      <div class="col-md-3 mb-3">
        <label class="input-label d-block"> {{ 'classification.archived' | translate }} </label>
        <p-inputSwitch formControlName="archive" binary="true"></p-inputSwitch>
      </div>
      <div class="col-md-12 mb-3">
        <label class="input-label d-block"> {{ 'classification.classificationCode' | translate }} * </label>

        <p-dropdown
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="classementsLV | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="'classification.chooseACode' | translate"
          [showClear]="true"
          formControlName="classementId">
        </p-dropdown>
      </div>
      <div class="col-md-12 mb-3">
        <label class="input-label d-block"> {{ 'classification.description' | translate }} * </label>
        <textarea rows="5" cols="30" formControlName="description" class="super-compos-input-text form-control w-100" pInputTextarea></textarea>
      </div>
      <div class="col-md-12 mb-3">
        <label class="input-label d-block"> {{ 'classification.location' | translate }} </label>
        <i-input
          [iInput]="{ placeholder: 'classification.location' | translate }"
          [type]="'text'"
          [control]="formCreateEditBinder.get('localisation')"
          [showError]="false"
          styleClass="d-block w-100"></i-input>
      </div>
      <div class="col-md-12 mb-3">
        <label class="input-label d-block"> {{ 'classification.remarks' | translate }} </label>
        <textarea rows="3" cols="30" formControlName="remarques" class="super-compos-input-text form-control w-100" pInputTextarea></textarea>
      </div>
    </form>
  </section>

  <i-button styleClass="bottomButton red mb-3" [text]="'cancel' | translate" (click)="closeModalBinderCreateEdit(false)"></i-button>
  <i-button styleClass="bottomButton green mb-3" (click)="createBinder('single')" [text]="'classification.createABinder' | translate"> </i-button>
  <i-button styleClass="bottomButton green" (click)="createBinder('multiple')" [text]="'classification.addAndCreateAnotherBinder' | translate">
  </i-button>
</div>
